import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import UserMessage from './UserMessage';
import BotMessage from './BotMessage';
import TypingIndicator from './TypingIndicator';

import HandOverMessage from '../MetaMessages/HandOverMessage';
import HandBackMessage from '../MetaMessages/HandBackMessage';
import RequestOperatorMessage from '../MetaMessages/RequestOperatorMessage';
import HoldMessage from '../MetaMessages/HoldMessage';
import { checkIsInOperatorConversation } from './BotMessage/utils';

class ScrollIntoViewWrapper extends Component {
  constructor(props) {
    super(props);
    this.scrollWrapperRef = createRef();
  }

  componentDidMount() {
    if (this.props.scrollIntoView) {
      setTimeout(() => {
        if (this.scrollWrapperRef.current) {
          this.scrollWrapperRef.current.scrollIntoView();
        }
      }, 200);
    }
  }

  render() {
    const { children, activity, messageWrapper } = this.props;
    const messageComponent = !messageWrapper
      ? children
      : React.createElement(messageWrapper, { activity }, children);

    return <div ref={this.scrollWrapperRef}>{messageComponent}</div>;
  }
}

class MessageBuilder extends Component {
  render() {
    const { user, activity, blockPosition } = this.props;

    if (activity.type === 'event') {
      return null;
    }

    if (activity.type === 'operatorHandOver') {
      return <HandOverMessage activity={activity} />;
    }
    if (activity.type === 'operatorHold') {
      return <HoldMessage activity={activity} />;
    }
    if (activity.type === 'operatorHandBack') {
      return <HandBackMessage activity={activity} />;
    }
    if (activity.type === 'operatorRequest' || activity.name === 'operatorRequest') {
      return <RequestOperatorMessage />;
    }
    if (activity.type === 'operatorRequestTimeout' || activity.name === 'operatorRequestTimeout') {
      return <RequestOperatorMessage msg="Sorry, no agents currently available" />;
    }
    if (user && activity.from && activity.from.id === user.id) {
      return <UserMessage activity={activity} blockPosition={blockPosition} />;
    }
    return <BotMessage activity={activity} blockPosition={blockPosition} />;
  }
}

export default class Message extends Component {
  static propTypes = {
    user: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    })
  };

  render() {
    const { user, activity, blockPosition, messageWrapper } = this.props;

    if (activity.type === 'typing') {
      return (
        <TypingIndicator
          inOperatorConversation={checkIsInOperatorConversation(activity)}
          from={(activity.from && activity.from.name) || ''}
        />
      );
    }
    return (
      <ScrollIntoViewWrapper
        activity={activity}
        messageWrapper={messageWrapper}
        scrollerRef={this.props.scrollerRef}
        scrollIntoView={activity.scrollIntoView}
      >
        <MessageBuilder user={user} activity={activity} blockPosition={blockPosition} />
      </ScrollIntoViewWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MessageHistory/Message.js